import User from '@/pages/User';
import UserAccount from '@/pages/UserAccount';
import UserPassword from '@/pages/UserPassword';

export default [
  {
    path: '/account',
    component: User,
    meta: {
      title: '',
      requiresAuth: true,
      permissions: ['perm_modify_own_setting'],
    },
    children: [
      {
        path: '',
        name: 'user.account',
        component: UserAccount,
      },
      {
        path: '/password',
        name: 'user.password',
        component: UserPassword,
      },
    ],
  },
];
